import { Injectable } from '@angular/core';
import { EnvConfigurationService } from '../envconf/envconf.service';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { StockDto, StockNoIdDto } from '../../models/stock/stock-dto';
import { ApiService } from '../api/api.service';
import { Pagination } from '../../models/pagination';
import { PaginatedResponse, PaginatorFilters } from '@michelin/theme';

@Injectable({
  providedIn: 'root'
})
export class StockService {
  endpoint = `${EnvConfigurationService.configuration.BACKEND_URL}${EnvConfigurationService.configuration.BACKEND_SUB_PATH}/michelin/stock/products`;

  constructor(private readonly http: HttpClient, private readonly apiService: ApiService) {}

  getPaginatedResponse(pagination: Pagination<StockDto>): PaginatedResponse<StockDto> {
    return {
      count: pagination.totalElements,
      items: pagination.content
    };
  }

  search(paginatorFilters?: PaginatorFilters): Observable<PaginatedResponse<StockDto>> {
    return this.http
      .get<PaginatedResponse<StockDto>>(`${this.endpoint}${this.apiService.getQueryParams(paginatorFilters)}`)
      .pipe(map((items: Pagination<StockDto>) => this.getPaginatedResponse(items)));
  }
}
